import Vue from 'vue';
import Axios from 'axios';

const axios = Axios.create({
	baseURL: process.env.VUE_APP_API_URL,
	headers: {
		post: {
			'Accept': 'application/json'
		}
	}
});

Vue.axios = axios;
Vue.prototype.$http = axios;

export default axios;
